import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@thiememeulenhoff/ng-sdk';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'edu-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
})
export class AdminHeaderComponent {}
